import { COUNTRY_CURRENCY_MAP } from '#constants';

export const META_PIXEL_ID = '612239471666324';
const YEARLY_SLUG = 'nature-lovers-yearly-subscription';

function phoneFromUser(user) {
  const contacts = user?.contacts || [];
  const phone = contacts.find((contact) => contact.type === 'phone' && contact.contactId);
  return phone?.contactId || '';
}

function applyAdvancedMatching(user) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function' || !user) return;
  const payload = {};
  if (user.email) payload.em = String(user.email).trim().toLowerCase();
  const phone = phoneFromUser(user).replace(/\D/g, '');
  if (phone) payload.ph = phone;
  if (user._id) payload.external_id = String(user._id);
  if (Object.keys(payload).length) {
    window.fbq('init', META_PIXEL_ID, payload);
  }
}

function yearlyAmount(get, currency) {
  const yearly = (get().plans || []).find((plan) => plan.slug === YEARLY_SLUG);
  const amount =
    yearly?.cost?.find((cost) => cost.currency === currency)?.amount ??
    yearly?.cost?.[0]?.amount;
  const value = Number(amount);
  return Number.isFinite(value) ? value : 0;
}

/**
 * Value and content for commerce events.
 * `charged` uses the amount the customer actually pays.
 * `fallbackYearly` fills AddToCart before a plan is chosen.
 */
export function metaCommerceParams(get, { fallbackYearly = false, charged = false } = {}) {
  const currency = COUNTRY_CURRENCY_MAP[get().location?.country] || 'USD';
  let value = Number(get().getCheckoutCost());
  if (!Number.isFinite(value)) value = 0;
  if (value <= 0 && fallbackYearly && !charged) {
    value = yearlyAmount(get, currency);
  }
  const params = {};
  if (charged || value > 0) {
    params.value = value;
    params.currency = currency;
  }
  const outing = get().outing;
  const plan = (get().plans || []).find((item) => item.slug === get().planSlug);
  if (outing?.name) params.content_name = outing.name;
  else if (plan?.name) params.content_name = plan.name;
  if (plan?.slug) {
    params.content_ids = [plan.slug];
    params.content_type = 'product';
  } else if (outing?._id) {
    params.content_ids = [String(outing._id)];
    params.content_type = 'product';
  }
  return params;
}

export const sendFBEvent = (set, get, { eventName, params, commerce } = {}) => {
  let custom = params ? { ...params } : {};
  if (commerce === 'intent') {
    custom = { ...metaCommerceParams(get, { fallbackYearly: true }), ...custom };
  } else if (commerce === 'checkout') {
    custom = { ...metaCommerceParams(get, { charged: true }), ...custom };
  }
  const hasCustom = Object.keys(custom).length > 0;

  if (process.env.REACT_APP_ENV !== 'prod') {
    console.log('FB Event:', eventName, hasCustom ? custom : undefined);
    return;
  }

  try {
    applyAdvancedMatching(get().user);
    if (typeof window.fbq !== 'function') return;
    if (hasCustom) {
      window.fbq('track', eventName, custom);
    } else {
      window.fbq('track', eventName);
    }
  } catch (err) {
    console.error('Error sending Facebook event:', err);
  }
};
